<template>

    <div>

        <navbar></navbar>

        <div class="mx-auto container text-white flex justify-between items-center py-2 px-2 md:px-0">
            <div class="flex items-center">
                <div v-if="userData !== null && userData.is_active" class="-ml-2"><div class="blob"></div></div>
                <h2 class="text-2xl">{{ userData.name }}</h2>
            </div>
            <button class="bg-blue-dark text-white rounded-lg px-4 py-2 focus:outline-none" disabled>
                Follow Chaser
            </button>
        </div>

        <div class="mx-0 my-0">
            <div :style="{height: height + 'px'}">
                <div class="bg-black" style="overflow-x: hidden; overflow-y:hidden; position:relative; width:100%; height: 100%">
                    <BackgroundBlur :url="'http://edge.livestormchasing.com/thumbnails/' + this.userData.stream_keys[0].stream_id + '.jpg?t=' + new Date().getTime()" />
                    <div ref="playerWidth" class="mx-auto container w-full h-full flex justify-center">
                        <div style="max-height: 100%; position:relative; max-width:100%; width: 100%;">
                            <StreamPlayer :streamId="this.userData.stream_keys[0].stream_id" :watermark="true" :ads="false" class="embed-responsive-item" style="height:100%" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="">
            <ChaserMap />
        </div> -->

        <div class="px-2">
            <div class="container mx-auto py-4">
                <h2 class="text-grey-lightest">{{ userData.name }}'s Most Recent Videos</h2>
                <p class="text-grey-dark mt-1">View {{ userData.name }}'s' most recent video from their chases. Some chasers typically upload 2-3 high quality videos per chase!</p>

                <div class="flex flex-row flex-wrap -mx-2" v-if="!loading">
                    <div class="w-full md:w-full lg:w-1/2 px-2 cursor-pointer" v-for="video in videos" v-on:click="goToVideo(video)">
                        <div id="holder" class="h-auto">
                            <div id="anim" class="relative">
                                <div class="flex flex-col sm:flex-row mt-4 rounded-lg bg-white select-none">
                                    <img class="h-auto sm:h-24 rounded-t-lg sm:rounded-l-lg sm:rounded-r-none" style="object-fit: cover;" :src="thumbnailImage(video.created_at, video.upload_id)" />
                                    <div class="p-2 flex flex-col justify-between">
                                        <strong>{{ video.title }}</strong>
                                        <p class="text-sm text-grey-dark mt-1 sm:mt-0">{{ video.user }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="w-full px-2 mt-2 text-white" v-if="videos.length == 0">
                        No videos yet! Please check back soon.
                    </div>
                </div>

                <div class="flex flex-row justify-center" v-if="loading">
                    <div class="text-center py-10">
                        <h1><i class="fas fa-spinner-third fa-spin text-grey-light"></i></h1>
                    </div>
                </div>

            </div>
        </div>

        <page-footer></page-footer>
                    
    </div>

</template>

<script>

    import * as Config from '@/config'
    import { mapActions, mapGetters } from 'vuex';

    import Navbar from '@/components/Navbar'
    import Chat from '@/components/Modules/Chat'
    import VideoPlayer from '@/components/Modules/VideoPlayer'
    import StreamPlayer from '@/components/Modules/StreamPlayer'
    import PageFooter from '@/components/PageFooter'
    import moment from 'moment'

    import BackgroundBlur from './BackgroundBlur.vue'
    import ChaserMap from './ChaserMap.vue'

    export default {
        name: 'ChaserProfile',
        components: {
            PageFooter,
            Navbar,
            Chat,
            StreamPlayer,

            BackgroundBlur,
            ChaserMap
        },
        data() {
            return {
                loading: true,
                userData: null,
                followingStatus: false,
                height: 675,
                videos: {},
            }
        },
        mounted() {
            this.getChaserDetails()

            var _this = this
            setTimeout(function() {
                _this.height = _this.$refs.playerWidth.clientWidth * 9/16
            }, 200)

            window.addEventListener("resize", this.resize)           
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
                'isAuthenticated'
            ]),
            getChaserDetails() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v1/chasers/" + this.$route.params.profile).then((response) => {
                    this.$set(this, 'userData', response.data);
                    this.$set(this, 'loading', false);
                    // _this.$http.get(Config.apiPath + "/api/v1/follow/" + this.userData.id, this.getAuthorizationHeader()).then((response) => {
                    //     this.$set(this, 'followingStatus', response.data.following);
                    // });
                    _this.getChaserVideos(response.data.name)
                });
            },
            getChaserVideos(name) {
                this.$http.get(Config.apiPath + "/api/v1/videos/search?name=" + name).then((response) => {
                    this.$set(this, 'videos', response.data);
                });
            },
            followChaser() {
                this.$http.post(Config.apiPath + "/api/v1/follow/" + this.userData.id, null, this.getAuthorizationHeader()).then((response) => {
                    this.$set(this, 'followingStatus', response.data.success);
                });
            },
            unfollowChaser() {
                this.$http.delete(Config.apiPath + "/api/v1/unfollow/" + this.userData.id, {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('access_token')
                    }
                }).then((response) => {
                    this.$set(this, 'followingStatus', response.data.status);
                    console.log(response)
                });
            },
            resize() {
                var _this = this
                setTimeout(function() {
                    console.log(_this.$refs)
                    _this.height = _this.$refs.playerWidth.clientWidth * 9/16
                }, 200)
            },
            thumbnailImage(date, id) {
                var date = moment.utc(date);
                var isAfter = moment(date).isAfter('2018-05-27 00:06:00');

                if(isAfter) {
                    return 'https://media-preview.livestormsvideo.com/thumbnails/' + date.year() + "/" + (date.month() + 1) + "/" + date.date() + "/" + id + "-00001.png";
                }
                return 'https://lsm-mms.s3.amazonaws.com/thumbnails/' + date.year() + "/" + (date.month() + 1) + "/" + date.date() + "/" + id + "-1.jpg";
            },
            goToVideo(video) {
                window.open('https://youtu.be/' + video.youtube_id, '_blank');
            }

        }
    }

</script>
